
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in-en",
      function () {
        return require("private-next-pages/in-en.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in-en"])
      });
    }
  